export enum Partitions {
    all = "",
    part_1 = 1,
    part_2 = 2,
    part_1_hide_2 = 3,
    part_2_hide_1 = 4,
}
